const convertSpacingsToCSS = (spacings) => ({
    '--spacing-0': `${spacings.s0}px`,
    '--spacing-2': `${spacings.s2}px`,
    '--spacing-4': `${spacings.s4}px`,
    '--spacing-6': `${spacings.s6}px`,
    '--spacing-8': `${spacings.s8}px`,
    '--spacing-10': `${spacings.s10}px`,
    '--spacing-12': `${spacings.s12}px`,
    '--spacing-16': `${spacings.s16}px`,
    '--spacing-24': `${spacings.s24}px`,
    '--spacing-32': `${spacings.s32}px`,
    '--spacing-40': `${spacings.s40}px`,
    '--spacing-44': `${spacings.s44}px`,
    '--spacing-48': `${spacings.s48}px`,
    '--spacing-56': `${spacings.s56}px`,
    '--spacing-64': `${spacings.s64}px`,
    '--spacing-72': `${spacings.s72}px`,
});
var Spacings;
(function (Spacings) {
    Spacings["s0"] = "var(--spacing-0)";
    Spacings["s2"] = "var(--spacing-2)";
    Spacings["s4"] = "var(--spacing-4)";
    Spacings["s6"] = "var(--spacing-6)";
    Spacings["s8"] = "var(--spacing-8)";
    Spacings["s10"] = "var(--spacing-10)";
    Spacings["s12"] = "var(--spacing-12)";
    Spacings["s16"] = "var(--spacing-16)";
    Spacings["s24"] = "var(--spacing-24)";
    Spacings["s32"] = "var(--spacing-32)";
    Spacings["s40"] = "var(--spacing-40)";
    Spacings["s44"] = "var(--spacing-44)";
    Spacings["s48"] = "var(--spacing-48)";
    Spacings["s56"] = "var(--spacing-56)";
    Spacings["s64"] = "var(--spacing-64)";
    Spacings["s72"] = "var(--spacing-72)";
})(Spacings || (Spacings = {}));

export { Spacings, convertSpacingsToCSS };
